// extracted by mini-css-extract-plugin
module.exports = {"modelName":"ModelName_modelName__l6FeI"};